import * as _ from 'lodash';
import toast from 'react-hot-toast';

import { logout } from './auth';
import { isFetching } from './preloader';

/**
 * Map raw backend error strings to user-friendly messages.
 * Called before firing the error toast.
 *
 * Note: the backend returns a generic "Duplicate key error." for every
 * unique-constraint violation (dishes, dish_components, product_categories,
 * suggested_products, ingredients, etc.), so we cannot tell from the message
 * which constraint failed. Use a neutral message here.
 * The long-term fix is for the backend to return a specific message; this
 * mapper will then pass those through unchanged.
 */
const humanizeApiError = (rawMessage) => {
  if (!rawMessage || typeof rawMessage !== 'string') return rawMessage;

  if (rawMessage.includes('Duplicate key error')) {
    return 'This record already exists';
  }

  return rawMessage;
};

export const actionWrapper = (action, errorCallback) => async (dispatch, getState) => {
  try {
    dispatch(isFetching(true));
    const newState = await action(dispatch, getState);
    if (newState) {
      dispatch(newState);
    }
    dispatch(isFetching(false));
  } catch (error) {
    dispatch(isFetching(false));
    const response = _.get(error, 'request.response');

    if (!response) {
      toast.error('Server error', {
        position: 'bottom-right',
        duration: 3000,
      });
      // Prevent falling through to the try/catch below and firing a second toast.
      return;
    }

    try {
      const responseData = JSON.parse(response);

      if (responseData.error === 'jwt expired') {
        return dispatch(logout());
      }

      if (errorCallback) {
        errorCallback(humanizeApiError(responseData.error), dispatch);
      } else {
        const errorMessage = humanizeApiError(
          responseData.error || error.message || 'Server error'
        );

        toast.error(errorMessage, {
          position: 'bottom-right',
          duration: 3000,
        });
      }
    } catch (parseError) {
      const errorMessage = humanizeApiError(error.message || 'Server error');

      toast.error(errorMessage, {
        position: 'bottom-right',
        duration: 3000,
      });
    }
  }
};